import axios from '../axiosConfig';

export const getRoutes = async (
  entityId,
  { includeInactive = false, include = 'stops' } = {},
) => {
  const response = await axios.get(`/api/routes/${entityId}`, {
    params: {
      includeInactive,
      include,
    },
  });

  return response.data;
};
